<script>
  import { Title, Content } from '@smui/paper';
  import Button, { Label, Icon } from '@smui/button';
  import Checkbox from '@smui/checkbox';
  import FormField from '@smui/form-field';
  import { createEventDispatcher } from 'svelte';
  import { pluralise } from '$lib/client/utils/typography';

  export let ask;

  const artist = ask.context;
  const dispatch = createEventDispatcher();
  const plural = pluralise(artist.name);
</script>

<Title>{ask.title ? ask.title : `${plural} want you to visit this link`}</Title>
<Content>
  <p>{ask.content}</p>

  <nav class="actions b--secondary b--solid-t-tiny u-mt u-pt">
    <slot name="actions" />

    <Button
        class="complete-ask"
        color="primary"
        variant="raised"
        href={ask.url}
        target="_blank"
        rel="noopener"
        on:click={() => dispatch('completed')}
        >
        <Label>Get Tickets</Label>
        <Icon class="material-icons">navigate_next</Icon></Button
                                                         >
  </nav>
</Content>
